<section [ngClass]="[darkMode ? 'dark' : '', expand ? '' : 'w-75px']">
  <div class="side-menu {{expand ? '' : 'expand'}}">
    <div class="user" *ngIf="user">
      <img loading="lazy" [src]="user.avatar ? user.avatar : '../../../../assets/user-avater.jpg'"
        class="rounded-circle">
      <!-- <p-skeleton shape="circle" width="50px" height="50px" *ngIf="user && !user.avatar"></p-skeleton> -->
      <div class="name">
        <div class="role" *ngIf="user && expand">{{ user.banStatus }}</div>
        <p-skeleton width="70px" height="18px" borderRadius="999px" *ngIf="user &&!user.banStatus"
          styleClass="mb-2"></p-skeleton>

        <div class="user-name text-capitalize" *ngIf="user && expand"> {{ user.name ? user.name.split(' ')[0] : '' }}
        </div>
        <p-skeleton width="100px" height="18px" borderRadius="999px" *ngIf="user && !user.name"></p-skeleton>

      </div>
      <div class="mode flex-grow-1 text-end">
        <i [ngClass]="['pi', darkMode ? 'pi-sun text-light light-mode' : 'pi-moon dark-mode']"
          (click)="[darkMode = !darkMode, setKeyForMode()] "></i>
        <i (click)="expand =! expand;" class=" pi "
          [ngClass]="[ darkMode ? ' text-light light-mode' : 'dark-mode', expand ? 'pi-chevron-left' : 'pi-chevron-right']"></i>
      </div>
    </div>
    <div class="items main">
      <div class="items-title" *ngIf="expand">Main</div>
      <!-- ================ Dashboard ====================== -->
      <div class="item">
        <div class="link" routerLink="/dashboard" (click)="collapseSiblings('')" routerLinkActive="route-active">
          <i class="icon pi pi-home"></i>
          <div class="label">Dashboard</div>
        </div>
      </div>
      <!-- ================ Categories ( dropdown ) ====================== -->
      <div class="item">
        <div class="link {{ mainExpanders.categories ? 'route-active' : '' }}"
          (click)="mainExpanders.categories = !mainExpanders.categories; collapseSiblings('categories')">
          <i class="icon pi pi-sitemap"></i>
          <div class="label">Categories</div>
          <i class="pi pi-chevron-down"></i>
        </div>
        <div class="sub-menu {{ mainExpanders.categories ? 'expand-dropdown-3' : '' }}">
          <div class="sub-menu-item {{ categoryRoutesActivation.mainCategory ? 'route-active' : '' }}"
            routerLinkActive="route-active" [routerLink]="['/panel/categories/main-category']">Main Categories</div>
          <div class="sub-menu-item {{ categoryRoutesActivation.category ? 'route-active' : '' }}"
            routerLinkActive="route-active" [routerLink]="['/panel/categories/categories-list']">Categories</div>
          <div class="sub-menu-item {{ categoryRoutesActivation.subCategory ? 'route-active' : '' }}"
            routerLinkActive="route-active" [routerLink]="['/panel/categories/sub-categories']">Sub Categories</div>
        </div>
      </div>
      <!-- ================ Products ( dropdown ) ====================== -->
      <div class="item">
        <div class="link {{ mainExpanders.products ? 'route-active' : '' }}"
          (click)="mainExpanders.products = !mainExpanders.products; collapseSiblings('products')">
          <i class="icon pi pi-th-large"></i>
          <div class="label">Product</div>
          <i class="pi pi-chevron-down"></i>
        </div>
        <div class="sub-menu {{ mainExpanders.products ? 'expand-dropdown-4' : '' }}">
          <div class="sub-menu-item" routerLink="/panel/products/products" routerLinkActive="route-active">
            <div class="label">All Products</div>
          </div>
          <div class="sub-menu-item" routerLink="/panel/products/new-product/form" routerLinkActive="route-active">
            <div class="label">New Product</div>
          </div>
          <div class="sub-menu-item" routerLink="/panel/products/flash-sale" routerLinkActive="route-active">
            <div class="label">Flash Sale</div>
          </div>
          <div class="sub-menu-item" routerLink="/panel/products/featured" routerLinkActive="route-active">
            <div class="label">Featured</div>
          </div>
        </div>
      </div>
      <!-- =================== Legal ( dropdown ) ==================== -->
      <div class="item" *ngIf="notallowCoustoumEmail">
        <div class="link {{ mainExpanders.legal ? 'route-active' : '' }}"
          (click)="mainExpanders.legal = !mainExpanders.legal; collapseSiblings('legal')">
          <i class="icon fa-solid fa-scale-balanced"></i>
          <div class="label">Legal</div>
          <i class="pi pi-chevron-down"></i>
        </div>
        <div class="sub-menu {{ mainExpanders.legal ? 'expand-dropdown-3' : '' }}">
          <div class="sub-menu-item" routerLink="/legal/FAQ" routerLinkActive="route-active">
            <div class="label">
              F A Q
            </div>
          </div>
          <div class="sub-menu-item" routerLink="/legal/blogs" routerLinkActive="route-active">
            <div class="label">
              Blogs
            </div>
          </div>
          <div class="sub-menu-item" routerLink="/legal/privacy-policy" routerLinkActive="route-active">
            <div class="label">
              Privacy Policy
            </div>
          </div>
        </div>
      </div>
      <ng-container *ngIf="!notallowCoustoumEmail">

        <!-- ================ Users ( dropdown ) ===================== -->
        <div class="item">
          <div class="link {{ mainExpanders.users ? 'route-active' : '' }}"
            (click)="mainExpanders.users = !mainExpanders.users; collapseSiblings('users')">
            <i class="icon pi pi-users"></i>
            <div class="label">Users</div>
            <i class="pi pi-chevron-down"></i>
          </div>
          <div class="sub-menu {{ mainExpanders.users ? 'expand-dropdown-5' : '' }}">
            <div class="sub-menu-item" routerLink="/panel/users/usersList" routerLinkActive="route-active">
              <div class="label">
                Users List
              </div>
            </div>
            <div class="sub-menu-item" routerLink="/panel/users/staff" routerLinkActive="route-active">
              <div class="label">
                Staff List
              </div>
            </div>
            <div class="sub-menu-item" routerLink="/panel/users/users-delivery-settings"
              routerLinkActive="route-active">
              <div class="label">
                Users Delivery Setting
              </div>
            </div>
            <div class="sub-menu-item" routerLink="/panel/users/rolesUsers" routerLinkActive="route-active">
              <div class="label">
                Roles
              </div>
            </div>
            <div class="sub-menu-item" routerLink="/panel/users/rankUsers" routerLinkActive="route-active">
              <div class="label">
                Ranks
              </div>
            </div>
          </div>
        </div>
        <!-- ================ Wallets ( dropdown ) =================== -->
        <div class="item">
          <div class="link {{ mainExpanders.wallet ? 'route-active' : '' }}"
            (click)="mainExpanders.wallet = !mainExpanders.wallet; collapseSiblings('wallet')">
            <i class="icon pi pi-wallet "></i>
            <div class="label">Wallets</div>
            <i class="pi pi-chevron-down"></i>
          </div>
          <div class="sub-menu {{ mainExpanders.wallet ? 'expand-dropdown-4' : '' }}">
            <div class="sub-menu-item" routerLink="/panel/wallets/wallets-list" routerLinkActive="route-active">
              <div class="label">Wallets List</div>
            </div>
            <div class="sub-menu-item" routerLinkActive="route-active" routerLink="/panel/wallets/transaction-logs">
              <div class="label">Transaction Logs</div>
            </div>
            <div class="sub-menu-item" routerLink="/panel/wallets/wallets-setting" routerLinkActive="route-active">
              <div class="label">Wallets Setting</div>
            </div>
            <div class="sub-menu-item" routerLink="/panel/wallets/quieck-links-top-up" routerLinkActive="route-active">
              <div class="label">quick links top up</div>
            </div>
          </div>
        </div>
        <!-- ================= Orders ( dropdown ) ==================== -->
        <div class="item">
          <div class="link {{ mainExpanders.order ? 'route-active' : '' }}"
            (click)="mainExpanders.order = !mainExpanders.order; collapseSiblings('order')">
            <i class="icon pi pi-list"></i>
            <div class="label"><span>Orders</span> <i *ngIf="ordersCounts || countTopups" class="pi pi-circle-on"></i>
            </div>
            <i class="pi pi-chevron-down"></i>
          </div>
          <div class="sub-menu {{ mainExpanders.order ? 'expand-dropdown-2' : '' }}">
            <div class="sub-menu-item event-value" routerLink="/panel/orders/ordersList"
              routerLinkActive="route-active">
              <div class="label">Orders List</div>
              <div class="event-value" *ngIf="acceptedOrdersCount" (click)="filterOrders('Accepted')">{{
                acceptedOrdersCount }}</div>
              <div class="event-value" *ngIf="ordersCounts" (click)="filterOrders('Processing')">{{ ordersCounts }}
              </div>
            </div>
            <div class="sub-menu-item event-value" routerLink="/panel/orders/top-up" routerLinkActive="route-active">
              <div class="label">Top Up List</div>
              <div class="event-value" *ngIf="countTopups" (click)="filterTopUpOrders('Processing')">{{ countTopups }}</div>
            </div>
          </div>
        </div>
        <!-- ================ Ticket ( dropdown ) ==================== -->
        <div class="item">
          <div class="link {{ mainExpanders.ticket ? 'route-active' : '' }}"
            (click)="mainExpanders.ticket = !mainExpanders.ticket; collapseSiblings('ticket')">
            <i class="icon pi pi-ticket"></i>
            <div class="label"><span>Tickets</span> <i *ngIf="ticketsCounts" class="pi pi-circle-on"></i></div>
            <i class="pi pi-chevron-down"></i>
          </div>
          <div class="sub-menu {{ mainExpanders.ticket ? 'expand-dropdown-2' : '' }}">
            <div class="sub-menu-item event-value" routerLink="/panel/tickets/ticket-list"
              routerLinkActive="route-active">
              <div class="label">Ticket System</div>
              <div class="event-value" *ngIf="ticketsCounts.open">{{ ticketsCounts.open }}</div>
            </div>
            <div class="sub-menu-item" routerLink="/panel/contactUs/contacts-list" routerLinkActive="route-active">
              <div class="label">Contact Us</div>
            </div>
          </div>
        </div>
        <!-- ================= Licenses ( dropdown ) ================= -->
        <div class="item">
          <div class="link {{ mainExpanders.license ? 'route-active' : '' }}"
            (click)="mainExpanders.license = !mainExpanders.license; collapseSiblings('license')">
            <i class="icon pi pi-dollar"></i>
            <div class="label">Licenses</div>
            <i class="pi pi-chevron-down"></i>
          </div>
          <div class="sub-menu {{ mainExpanders.license ? 'expand-dropdown-2' : '' }}">
            <div class="sub-menu-item" routerLink="/panel/licenses/licensesList" routerLinkActive="route-active">
              <div class="label">
                Licenses List
              </div>
            </div>
            <div class="sub-menu-item" routerLink="/panel/licenses/manager" routerLinkActive="route-active">
              <div class="label">
                Licenses Manager
              </div>
            </div>
          </div>
        </div>
        <!-- ================= Payment ( dropdown ) =================== -->
        <div class="item">
          <div class="link {{ mainExpanders.payment ? 'route-active' : '' }}"
            (click)="mainExpanders.payment = !mainExpanders.payment; collapseSiblings('payment')">
            <i class="icon pi pi-money-bill"></i>
            <div class="label">Payment</div>
            <i class="pi pi-chevron-down"></i>
          </div>
          <div class="sub-menu {{ mainExpanders.payment ? 'expand-dropdown-3' : '' }}">
            <div class="sub-menu-item" routerLink="/panel/payments/payment-board" routerLinkActive="route-active">
              <div class="label">Payments</div>
            </div>
            <div class="sub-menu-item" routerLink="/panel/payments/manual-payment" routerLinkActive="route-active">
              <div class="label">Manual Payment</div>
            </div>
            <div class="sub-menu-item" routerLink="/panel/payments/restrictions" routerLinkActive="route-active">
              <div class="label">Restrictions</div>
            </div>
          </div>
        </div>
        <!-- ================= Message ===================== -->
        <div class="item ">
          <div class="link" routerLink="/panel/message" (click)="collapseSiblings('') " routerLinkActive="route-active">
            <i class="icon fa-regular fa-comment-dots"></i>
            <div class="label">Message</div>
          </div>
        </div>
        <!-- ================= Notification ===================== -->
        <div class="item">
          <div class="link" routerLink="/panel/notifications" (click)="collapseSiblings('')"
            routerLinkActive="route-active">
            <i class="icon pi pi-bell"></i>
            <div class="label">Notification</div>
          </div>
        </div>
        <!-- =================== Reports ===================== -->
        <div class="item">
          <div class="link" routerLink="/panel/reports" (click)="collapseSiblings('')" routerLinkActive="route-active">
            <i class="icon pi pi-flag"></i>
            <div class="label">Reports</div>
          </div>
        </div>
        <!-- ================== Suppliers ==================  -->
        <div class="item">
          <div class="link" routerLink="/panel/suppliers" (click)="collapseSiblings('')"
            routerLinkActive="route-active">
            <i class="icon fa fa-headset"></i>
            <div class="label">Suppliers</div>
          </div>
        </div>
        <!-- =================== Sliders ============== -->
        <div class="item">
          <div class="link" routerLink="/panel/sliders-center" (click)="collapseSiblings('')"
            routerLinkActive="route-active">
            <i class="icon pi pi-sliders-h"></i>
            <div class="label">Sliders</div>
          </div>
        </div>
        <!-- =================== Legal ( dropdown ) ==================== -->
        <div class="item">
          <div class="link {{ mainExpanders.legal ? 'route-active' : '' }}"
            (click)="mainExpanders.legal = !mainExpanders.legal; collapseSiblings('legal')">
            <i class="icon fa-solid fa-scale-balanced"></i>
            <div class="label">Legal</div>
            <i class="pi pi-chevron-down"></i>
          </div>
          <div class="sub-menu {{ mainExpanders.legal ? 'expand-dropdown-3' : '' }}">
            <div class="sub-menu-item" routerLink="/legal/FAQ" routerLinkActive="route-active">
              <div class="label">
                F A Q
              </div>
            </div>
            <div class="sub-menu-item" routerLink="/legal/blogs" routerLinkActive="route-active">
              <div class="label">
                Blogs
              </div>
            </div>
            <div class="sub-menu-item" routerLink="/legal/privacy-policy" routerLinkActive="route-active">
              <div class="label">
                Privacy Policy
              </div>
            </div>
          </div>
        </div>
        <!-- ===================== Web Setting ( dropdown ) ================= -->
        <div class="item">
          <div class="link {{ mainExpanders.webSetting ? 'route-active' : '' }}"
            (click)="mainExpanders.webSetting = !mainExpanders.webSetting; collapseSiblings('webSetting')">
            <i class="icon pi  pi-wrench"></i>
            <div class="label">Web Setting</div>
            <i class="pi pi-chevron-down"></i>

          </div>
          <div class="sub-menu {{ mainExpanders.webSetting ? 'expand-dropdown-4' : '' }}">
            <div class="sub-menu-item" routerLink="/panel/web-setting" routerLinkActive="route-active">
              <div class="label">Setting</div>
            </div>
            <div class="sub-menu-item" routerLink="/panel/social-media" routerLinkActive="route-active">
              <div class="label">Social Media</div>
            </div>
            <div class="sub-menu-item" routerLink="/panel/mintanance" routerLinkActive="route-active">
              <div class="label">Maintenance</div>
            </div>
            <div class="sub-menu-item" routerLink="/panel/web-setting/generate-invoice" routerLinkActive="route-active">
              <div class="label">Generate Invoice</div>
            </div>
          </div>
        </div>
        <!-- ================== Activities ========================== -->
        <div class="item">
          <div class="link" routerLink="/panel/activity-log" (click)="collapseSiblings('')"
            routerLinkActive="route-active">
            <i class="icon pi pi-chart-bar"></i>
            <div class="label">
              Activities
            </div>
          </div>
        </div>
      </ng-container>

    </div>
    <div class="items setting">
      <div class="items-title" *ngIf="expand">Settings</div>
      <div class="d-flex flex-column justify-content-between links">
        <div class="item" (click)="collapseSiblings('')">
          <div class="link" routerLink="/panel/setting/profile" routerLinkActive="route-active">
            <i class="icon pi pi-user"></i>
            <div class="label">Profile</div>
          </div>
        </div>
        <div class="item logout">
          <div class="link" (click)="logout()">
            <i class="icon pi pi-sign-out"></i>
            <div class="label">Logout</div>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>